/**
 * Type definitions for ADMPrintApp integration via WLS protocol.
 * ADMPrintApp is a native Android app on MC33K devices that handles TCP printing to Hip printers.
 */

/**
 * Response from ADMPrintApp delivered via the WLS callback.
 * result: 0 = failure, non-zero = success.
 * extras: array of key-value pairs with additional status information.
 */
export interface AppIntentResponse {
    result: number;
    extras: Array<{
        name: string;
        value: string;
        type: string;
    }>;
}

/**
 * Configuration constants for ADMPrintApp communication.
 */
export interface AdmPrintConfig {
    timeoutMs: number;  // 30000 — covers ADMPrintApp's internal 3x retry with backoff
    port: number;       // 6101 — ADMPrintApp convention for Hip printers
}

export const ADM_PRINT_CONFIG: AdmPrintConfig = {
    timeoutMs: 30000,
    port: 6101
};

/**
 * RUM metric event shape for ADMPrintApp print attempts.
 */
export interface AdmPrintMetricEvent {
    Status: 'SUCCESS' | 'FAILURE' | 'TIMEOUT';
    Latency: number;
    Warehouse: string;
    Associate: string;
    PrinterIP: string;
}
